// extracted by mini-css-extract-plugin
export default {"benefits":"views-ContentPage-components-themes-BGH-benefits__benefits--eXEJf","benefit":"views-ContentPage-components-themes-BGH-benefits__benefit--r4mbK"};